
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import Avatar from "@mui/material/Avatar";

function DataCard(props) {
  const filterTitle = (title) => {
    return title
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  var count_arr = [];

  if (props.count === 3) {
    count_arr = [6, 4, 4];
  } else if (props.count === 4) {
    count_arr = [6, 6, 3];
  } else if (props.count === 5) {
    count_arr = [6, 6, 2.4];
  } else if (props.count === 2) {
    count_arr = [6, 6, 6];
  } else {
    count_arr = [12, 12, 12];
  }

  return (
    <Grid item xs={count_arr[0]} sm={count_arr[1]} md={count_arr[2]} p={1.5}>
      <Grid container direction="row" alignItems="center" spacing={1.5}>
        {/* Show Icon Only If URL is Passed */}
        {props.icon && (
          <Grid item>
            <Avatar
              src={props.icon}
              alt="icon"
              variant="square"
              sx={{ width: 28, height: 28 }}
            />
          </Grid>
        )}

        {/* Title and Value Section */}
        <Grid item xs>
          <MDTypography
            variant="caption"
            fontWeight="bold"
            color="secondary"
            textTransform="capitalize"
            sx={{ display: 'block', lineHeight: 1.4, mb: 0.5 }}
          >
            {filterTitle(props.title)}
          </MDTypography>
          <MDTypography 
            variant="body2" 
            fontWeight="medium"
            sx={{ lineHeight: 1.4 }}
          >
            {props.value || 'N/A'}
          </MDTypography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default DataCard;